module.exports = __webpack_public_path__ + "static/analog-photo-2-24573a3d09d81cc00b42b8ad8013eff1.jpg";